import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=a492fb1c&scoped=true"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=a492fb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a492fb1c",
  null
  
)

export default component.exports